declare const globalThis: { __DEV__?: boolean };

export const __DEV__: boolean = globalThis.__DEV__ === true;
